export default "/dist/files/facebook.d617f35e6b1adc8f340820e8d87c07b5.svg";